import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

import HeaderText from '../../components/communal/HeaderText';
import InteractionTimeout from '../../components/communal/InteractionTimeout';
import SetTitle from '../../components/communal/SetTitle';
import DestinationSwitch from '../../utilities/generic/DestinationSwitch';
import { generateId, formatDate } from '../../utilities/generic/Common.js'
import SimpleReactValidator from 'simple-react-validator';

class Autocomplete extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    autocomplete: null,
    autocomplete_date: null,
    validDetails: false,

    direction: "arriving"
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;

    if (value === "yes") {
      this.setState({[name]: true});
    }
    else if (value === "no") {
      this.setState({[name]: false});
    }
  }

  saveAutocomplete(autocomplete, arriving_app_id) {
    let autocompletes = JSON.parse(localStorage.getItem("autocompletes"))

    // Create autocompletes array if it doesn't exist
    if (autocompletes === null) {
      autocompletes = []
    }

    let created_at = formatDate(new Date())
    let autocompleteData = {
      "autocomplete": autocomplete,
      "arriving_app_id": arriving_app_id,
      "app_id": generateId(),
      "version": process.env.REACT_APP_COMMIT_HASH,
      "created_at": created_at
    }

    // Append to autocompletes array, and save to semi-permanent storage
    autocompletes.push(autocompleteData)
    localStorage.setItem("autocompletes", JSON.stringify(autocompletes))
  }

  handleSubmit(event) {
    if (this.validator.allValid()) {
      this.saveAutocomplete(this.state.autocomplete, this.props.location.state.arriving_app_id)
      this.setState({ validDetails: true })
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }

    event.preventDefault()
  }

  render() {
    const cookies = new Cookies()
    const token = cookies.get('device_token')

    if (token === undefined) {
      return <Redirect to="/setup/user"/>
    }

    if (this.props.location.state === undefined) {
      return <Redirect to="/404" />
    }

    let profile = this.props.location.state.profile
    let person = this.props.location.state.person
    let arriving_app_id = this.props.location.state.arriving_app_id
    let direction = this.props.location.state.direction
    let planned_event_ids = this.props.location.state.planned_event_ids

    const destinationSwitch = new DestinationSwitch({ current_page: "autocomplete", profile: profile, person: person, arriving_app_id: arriving_app_id, direction: direction, planned_event_ids: planned_event_ids });

    if (this.state.validDetails) {
      return destinationSwitch.redirect()
    }

    const submit_button_value = destinationSwitch.buttonName()

    return (
      <div className="main-page arriving-page">
        <InteractionTimeout seconds={60} />

        <SetTitle title={"AutoComplete"} />
        <HeaderText />

        <div className="content">
          <div className="widget form">
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <div className="message"> 
                <p><b>Enable Auto Complete?</b></p>
                <p>Enable Auto Complete to speed up future check-ins and check-outs by securely recognising your details from previous visits.</p>
                <p>When enabled, the system may suggest your record based on information such as your name, email address, or phone number to help you check in faster.</p>
                <p>For privacy, parts of your email address and phone number are hidden when shown on screen. However, first name and last name won't be obscured.</p>
                <p>You can choose to skip Auto Complete if you would prefer other people to not see your details.</p>

                {this.state.autocomplete_date && (
                  <div className='small-text'>
                    Last selected at: {this.state.autocomplete_date}
                  </div>
                )}
              </div>

              <div className="feedback-page">
                <div className="radio">
                  <input className="column no" id="no_autocomplete" type="checkbox" value="no" name="autocomplete" checked={this.state.autocomplete === false} onChange={this.handleChange}></input>
                  <label className="longer" htmlFor="no_autocomplete">No</label>
                  <input className="column yes" id="yes_autocomplete" type="checkbox" value="yes" name="autocomplete" checked={this.state.autocomplete === true} onChange={this.handleChange}></input>
                  <label className="longer" htmlFor="yes_autocomplete">Yes</label>
                  {this.validator.message('above', this.state.autocomplete, 'required', { className: 'error top-margin' })}
                </div>
              </div>
              <br />

              <input type="submit" value={submit_button_value} />
            </form>
          </div>
        </div>

        <div></div>
      </div>
    );
  }

  componentDidMount() {
    let person = this.props.location.state?.person

    if (person?.autocomplete_date) {
      this.setState({autocomplete: person.autocomplete, autocomplete_date: person.autocomplete_date})
    }
  }
}

export default Autocomplete;
